import React, { Component } from "react";
import Image from 'react-image-webp';
import $ from 'jquery';

import listaProdutos from '../assets/js/data/produtos.json';

class Produtos extends Component {
  
    componentDidMount() {
        
        var $cell = $('.image__cell');
        
        $cell.find('.image--basic').click(function() {
            var $thisCell = $(this).closest('.image__cell');
            
            if ($thisCell.hasClass('is-collapsed')) {
                $cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed');
                $thisCell.removeClass('is-collapsed').addClass('is-expanded');
            } else {
                $thisCell.removeClass('is-expanded').addClass('is-collapsed');
            }
        });
        
        $cell.find('.expand__close').click(function(){
            
            var $thisCell = $(this).closest('.image__cell');
            
            $thisCell.removeClass('is-expanded').addClass('is-collapsed');
        });

    }

    render() {
        const produtos = listaProdutos.produtos;
        return (
            <section id="produtos" className="products-area pt-120" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="800">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <section className="image-grid">
                            {Object.keys(produtos).map((v, i) => 
                                <div className="image__cell is-collapsed" key={produtos[v].key}>
                                    <div className="image--basic">
                                        <a href={"#"+produtos[v].key}>
                                            <Image id={produtos[v].key} className="basic__img" alt={produtos[v].nome} src={require('../assets/images/produtos/'+produtos[v].imagem)} webp={require('../assets/images/webp/'+produtos[v].webp)} />
                                        </a>
                                        <div className="arrow--up"></div>
                                    </div>
                                    <div className="image--expand">
                                        <span className="expand__close"></span>
                                        <div className="container pt-40 pb-40">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Image className="image--large" alt={produtos[v].nome} src={require('../assets/images/produtos/'+produtos[v].imagem)} webp={require('../assets/images/webp/'+produtos[v].webp)} />
                                                </div>
                                                <div className="col-lg-6">
                                                    <h3>{produtos[v].titulo}</h3>
                                                    <h5>{produtos[v].subtitulo}</h5>
                                                    <p className="pt-20">{produtos[v].descricao}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Produtos;